'use strict'

/**
 * アプリケーション設定
 */

// アプリケーションバージョン
const version = 'v1'
// ホームページ
const homepage = 'Index'
// オンラインチャージサイト
const MFOnlinChageUrl = 'https://first-kitchen.onlinecharge.jp/'
// 注文受付処理中画面ポーリング間隔(秒)
const porllingInterval = 5
// 企業名の定義
const companyName = {
  FK: 'First Kitchen',
  WFK: 'Wendy\'s x First Kitchen'
}
// プライバシーポリシー
const privacyPolicyUrl = 'https://www.first-kitchen.co.jp/privacy/'

/**
 * GeolocationAPI設定
 * GeolocationAPIの動作を設定します。
 */
const geolocation = {
  watchTime: 1000, // 座標取得開始からの監視時間(ミリ秒)
  msg: {
    ja: {
      ERR01: '位置情報の利用許可を設定してください。',
      ERR02: '位置情報の利用が許可されていません。',
      ERR03: 'デバイスの位置の判定に失敗しました。',
      ERR04: 'タイムアウトしました。'
    },
    en: {
      ERR01: 'Your current browser does not support location services. Please use a different browser and try again.',
      ERR02: 'Your location services feature is not enabled. Please enable this feature.',
      ERR03: 'Unable to get your location information. Please check if you are unable to receive GPS signals or if your location services feature is disabled.',
      ERR04: 'Timed out.'
    }
  },
  options: {
    enableHighAccuracy: false,
    timeout: 5000, // GeolocationAPIのタイムアウト時間設定(ミリ秒)
    maximumAge: 3000000
  }
}

/**
 * API設定
 * APIにリクエストするための設定とパスを定義する
 */
const apiSetting = {
  baseUrl: process.env.VUE_APP_DOMAIN_URL,
  path: {
    Login: '/auth/login',
    EmailLogin: '/auth/emaillogin', // メールログイン
    EmailAuth: '/auth/emailauth', // メール認証
    UserInfo: '/auth/userinfo', // 2重ログイン防止用ユーザー情報取得
    AreaList: '/store/arealist',
    StoreList: '/store/storelist',
    StoreInfo: '/store/storeinfo',
    MenuCategory: '/menu/categories', // NOTE ph1.0で廃止
    MenuItemList: '/menu/itemlist', // NOTE ph1.0で廃止
    SetMenuList: '/menu/setmenulist', // NOTE ph1.0で廃止
    SetMenuDetail: '/menu/setmenudetail',
    Coupon: '/coupon',
    AmountCalculation: '/amount/executecalculation',
    OrderConfirm: '/order/confirm',
    MainteStatus: '/corp/getMainteStatus',
    GetCardInfo: '/payment/creditcard/getcardinfo',
    CreditCardExecPayment: '/payment/creditcard/execute',
    MFCardGetInfo: '/payment/mfcard/getcardinfo',
    MFCardGetTerminalInfo: '/payment/mfcard/getTerminalInfo',
    MFCardGetBalance: '/payment/mfcard/getbalance',
    MFCardExecPayment: '/payment/mfcard/execute',
    OrderProcessing: '/order/processstatus',
    OrderComplete: '/order/get',
    OrderHistory: '/order/history',
    DcmAuthStart: '/dcm/authstart',
    DcmGetHash: '/getDpayHash',
    DcmGetToken: '/payment/dcm/gettoken',
    DcmExecute: '/payment/dcm/execute',
    DcmUserInfoGet: '/dcm/userinfo/get',
    DcmUserInfoUpdate: '/dcm/userinfo/update',
    GetCategoryItem: '/menu/getCategoryItem',
    SetTableNumber: '/order/settablenumber',
    GetServerTime: '/getServerTime',
    PaymentRequestPreprocessing: '/payment/execPaymentRequestPreprocessing',
    GenSbpsHashKey: '/payment/genSbpsHashKey',
    GenOrderId: '/payment/genOrderId',
    GetSbpsCustCode: '/payment/getSbpsCustCode',
    GenBase64: '/payment/genBase64',
    GetTicketNumber: '/payment/getTicketNumber',
    SaveStorage: '/saveStorage',
    GetStorage: '/getStorage'
  },
  requestHeaders: {
    accept: 'application/json',
    'Content-Type': 'application/json; charset=UTF-8'
  }
}

/**
 * SBPS設定
 */
const sbpsSetting = {
  // 共用環境
  develop: {
    merchantId: '30132',
    serviceId: '002'
  },
  // 試験環境
  staging: {
    merchantId: '75730',
    serviceId: '001',
    itemId: 'FKMO',
    itemName: 'FKモバイルオーダー',
    payRequestURL: 'https://stbfep.sps-system.com/f01/FepBuyInfoReceive.do'
  },
  // 本番環境
  production: {
    merchantId: '75730',
    serviceId: '001',
    itemId: 'FKMO',
    itemName: 'FKモバイルオーダー',
    payRequestURL: 'https://fep.sps-system.com/f01/FepBuyInfoReceive.do',
    hashKey: '46340db4b791586b82a76799f01ffc4b0af1fbfc'
  }
}

const appconfig = {
  appMode: process.env.VUE_APP_MODE,
  version,
  geolocation,
  apiSetting,
  homepage,
  MFOnlinChageUrl,
  sbpsSetting,
  porllingInterval,
  companyName,
  privacyPolicyUrl
}

export { appconfig }



// WEBPACK FOOTER //
// ./src/lib/appconfig.js